import React from 'react'; 
import FadeIn from "react-lazyload-fadein";
import PageSplash from './PageSplash';
import WithConsumer from '../../context/WithConsumer';

const Page = ({ context }) => {

	let results = '';
		 
    const posts = () => context.posts;
    const post = posts()[0];
	
	const ctxPageLoaded = () => context.pageLoaded;
    const pageLoaded = ctxPageLoaded();
    
    function handleMenuToggle(evt) {
	  	evt.preventDefault();
	  	context.toggleMenu();
  	}
  	
  	function handlePrivacyToggle(evt) {
	  	evt.preventDefault();
	  	context.togglePrivacy();
  	}
     
    if (post) {
						
		if (context.appError){
		
			return null; 
		
		} else {
			
			return (
				<>
						
					<div className="c-page">
						
						
						<PageSplash post={post}></PageSplash>
													
					</div>
					
				</>
			)
				
		}
			
	} else {
		return null;
	}
};
export default WithConsumer(Page);